import { Helpers } from '../../../../utility/helpers';
import A11yTextWrapper from '../../../common/components/A11yTextWrapper/A11yTextWrapper';
import type { PriceData, PriceType } from '../../../common/models/priceData/priceData';

interface A11yPriceProps {
    priceData: PriceData;
    priceType: PriceType;
    className?: string;
}

const A11yPrice = ({ priceData, priceType, className }: A11yPriceProps) => {
    const { a11y, visual } = Helpers.toEcommerceAriaPriceWithCurrency(
        Helpers.getPrice(priceData, priceType) || 0,
    );

    return (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <A11yTextWrapper a11yText={a11y} a11yType="visuallyHiddenText" className={className}>
            {visual}
        </A11yTextWrapper>
    );
};

export default A11yPrice;
